import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TareaCasoMixedModel } from 'src/app/services/tareacaso.service';

@Component({
  selector: 'app-comentario-solicitar-revision',
  templateUrl: './comentario-solicitar-revision.component.html',
  styleUrls: ['./comentario-solicitar-revision.component.scss']
})
export class ComentarioSolicitarRevisionComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ComentarioSolicitarRevisionComponent>,
  ) { }

  ngOnInit(): void {
  }

  comment:string = ''
  sendCommnet(){
    this.dialogRef.close(this.comment)
  }
}
